let nSoftBasePath = "/nsoft"

export const getBaseRouterPath = () => {
  return nSoftBasePath;
};

export const setBaseRouterPath = (newPath) => {
  nSoftBasePath = newPath;
};
